import { AppShell } from '@mantine/core';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { Header } from './Header';
import { NavBar } from './Navbar';

export const MainLayout = () => {
  const [opened, setOpened] = useState(false);
  return (
    <AppShell
      header={{ height: 70 }}
      navbar={{ width: { sm: 200, lg: 300 }, breakpoint: 'sm', collapsed: { mobile: !opened } }}
      padding="md"
    >
      <Header opened={opened} setOpened={setOpened} />
      <NavBar opened={opened} />
      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
};
